import { IAssemblyData } from '../data/assembly/assembly';
import { IFurniture } from '../data/model/furniture';
import { modelManager } from '../manager/entityManager';
import { IPoint2d } from '../math/IPoint2d';
import { Point2dUtils } from '../math/Point2dUtils';
import { TGlobalStores } from '../stores';
import { EOperationType } from '../types/operation';

function isAssembly(entityData: IFurniture | IAssemblyData) {
  return 'accessorieIds' in entityData;
}

export class MeasureOperation {
  private _globalStore: TGlobalStores;
  private _history: TGlobalStores['history'];

  constructor(gs: TGlobalStores) {
    this._globalStore = gs;
    this._history = gs.history;
  }

  private $history_moveFurniture(entityData: IFurniture | IAssemblyData, offset: IPoint2d) {
    this._history.startOperation();
    if (isAssembly(entityData)) {
      const newAssemblyCenter = Point2dUtils.added(entityData.center, offset);
      this._globalStore.assemblyStore.updateAssemblyData(entityData.id, { center: newAssemblyCenter });

      for (const furnitureId of entityData.accessorieIds) {
        const furnitureData = this._globalStore.modelStore.getFurnitureData(furnitureId);
        if (furnitureData) {
          const newCenter = Point2dUtils.added(furnitureData.center, offset);
          this._globalStore.modelStore.updateFurnitureData(furnitureData.id, { center: newCenter });
        }
      }
    } else {
      const newCenter = Point2dUtils.added(entityData.center, offset);
      this._globalStore.modelStore.updateFurnitureData(entityData.id, { center: newCenter });
    }
    this._history.completeOperation(EOperationType.FurnitureModify);
  }

  moveFurniture(entityId: string, start: IPoint2d, end: IPoint2d, distance: number) {
    let targetEntityData: IFurniture | IAssemblyData;
    const currentEntityData =
      this._globalStore.modelStore.getFurnitureData(entityId) ??
      this._globalStore.assemblyStore.getAssemblyData(entityId);
    if (!currentEntityData || Point2dUtils.equals(start, end)) return;

    if (isAssembly(currentEntityData)) targetEntityData = currentEntityData;
    else {
      const allAssembly = this._globalStore.assemblyStore.getAssemblyDatas();
      targetEntityData = allAssembly.find((assembly) => assembly.accessorieIds.includes(entityId)) ?? currentEntityData;
    }

    const dirX = end.x - start.x;
    const dirY = end.y - start.y;
    const length = Math.hypot(dirX, dirY);
    const unitX = dirX / length;
    const unitY = dirY / length;

    const magnitude = Math.abs(distance);
    const directionSign = distance > 0 ? 1 : -1;
    const offset = { x: directionSign * unitX * magnitude, y: directionSign * unitY * magnitude };

    this.$history_moveFurniture(targetEntityData, offset);
    if (isAssembly(targetEntityData)) {
      modelManager.assemblyManager.updateAssembly({ id: entityId });
      for (const furnitureId of targetEntityData.accessorieIds) {
        modelManager.furnitureManager.updateEntity({ id: furnitureId });
      }
    } else {
      modelManager.furnitureManager.updateEntity({ id: entityId });
    }
  }
}
